export enum HighCommissionBoosting {
  NAME = 'plp_hc_boosting',
  OFF = 'off',
  ON = 'on',
}

export enum ClpPopulation {
  AUTO = 'auto',
  NAME = 'clp_population',
  QUERY = 'query',
}

export enum DeliveryCost {
  DISABLE = 'disable',
  ENABLE = 'enable',
  NAME = 'plp_show_delivery_cost',
}
